
export const GRID_COMPACTION_TYPE = "vertical"; // Can be set to vertical or horizontal or none.